export default "__VITE_ASSET__B6pB72vR__"